import React from "react";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import leftArrow from "../../../assets/images/svg/leftArrow.svg";
import useIsMobile from "customHooks/useIsMobile";
import classnames from "classnames";

const useStyles = makeStyles({
  root: {
    color: "#666666",
    padding: "10px 15px",
    fontSize: 12,
    background: "#FFFFFF",
    boxShadow: "0px 8px 16px rgb(0 0 0 / 8%)",
    transition: "0.3s",
    fontWeight: 300,
    borderRadius: 50,
    textTransform: "uppercase",
    height: 40,
    minWidth: "max-content",
    lineHeight: "22px",

    "@media (max-width: 576px)": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "50%",
      padding: 0,
    },

    "&:hover": {
      opacity: 0.8,
    },

    "& > img": {
      marginRight: 5,

      "@media (max-width: 576px)": {
        width: 18,
      },
    },
  },
  mobile: {
    height: 45,
    width: 45,
  },
});

const BackButtonLink = ({ to, children }) => {
  const classes = useStyles();
  const isMobile = useIsMobile();

  return (
    <Link className={classnames(classes.root, isMobile && classes.mobile)} to={to}>
      <img src={leftArrow} alt="back button" />
      {!isMobile && children}
    </Link>
  );
};

export default BackButtonLink;
